import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material/OutlinedInput';
import { inputLabelClasses } from '@mui/material/InputLabel';
import { styled } from '@mui/material/styles';
import palette from './palette.js';

const CustomTextField = styled(TextField)({
  [`& .${outlinedInputClasses.root}`]: {
    backgroundColor: palette.white,
    borderRadius: '10px',
    borderColor: palette.cyan,
  },
  [`& .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: palette.cyan,
    borderRadius: '10px',
  },
  [`&:hover .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]:
    {
      borderColor: palette.cyan,
    },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]:
    {
      borderColor: palette.cyan,
    },
  [`& .${inputLabelClasses.outlined}`]: {
    color: palette.cyan,
  },
});

const CustomTextFieldRound = styled(TextField)({
  [`& .${outlinedInputClasses.root}`]: {
    backgroundColor: palette.white,
    borderRadius: '50px',
    borderColor: palette.soft_blue,
  },
  [`& .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]: {
    borderColor: palette.soft_blue,
    borderRadius: '50px',
  },
  [`&:hover .${outlinedInputClasses.root} .${outlinedInputClasses.notchedOutline}`]:
    {
      borderColor: palette.soft_blue,
    },
  [`& .${outlinedInputClasses.root}.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]:
    {
      borderColor: palette.soft_blue,
    },
});

export { CustomTextFieldRound };
export default CustomTextField;
